<template>
  <div class="vip-present">
    <custom-modal v-model="visible" @on_cancel="closeModal">
      <template slot="body">
        <div class="body-wrap">
          <div class="tip-show">【新人专属VIP包】已放到您的账号</div>
          <div class="tip-show2">可在“个人中心” 查看</div>
          <p class="tip-check">
            <span class="checkvip" @click="handleOk"> 立即查看</span>
          </p>
        </div>
        <div class="header">
          <img @click="closeModal" src="@/assets/images/cut.png" alt="" />
        </div>
      </template>
    </custom-modal>
  </div>
</template>
<script>
// import VipCard from '@/apps/personal/components/VipCard'
import CustomModal from '@/components/common/CustomModal'
export default {
  name: 'VipPresent',
  data() {
    return {
      visible: this.value
    }
  },
  watch: {
    value: function(val) {
      this.visible = val
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CustomModal
    // VipCard
  },
  methods: {
    handleOk(e) {
      window.location.href = '/search/personal/mine'
    },
    closeModal(e) {
      console.log('Clicked cancel button')
      this.visible = false
      //登录成功后刷新下页面
      window.location.reload()
    }
  },
  // computed: {
  //   newcop: function() {
  //     // debugger
  //     return this.$store.state.coupon
  //   }
  // },
  mounted() {}
}
</script>
<style lang="scss">
.vip-present {
  .header {
    margin-top: 30px;
    text-align: center;
  }
  .body-wrap {
    width: 400px;
    padding: 40px;
    text-align: center;
    height: 310px;
    background-image: url('../../assets/images/new_card.png');
    .tip-check {
      text-align: center;
      margin-top: 140px;
    }

    .tip-show {
      text-align: center;
      display: inline-block;
      font-size: 20px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(119, 65, 23, 1);
      line-height: 28px;
    }
    .tip-show2 {
      margin-top: 7px;
      display: inline-block;
      text-align: center;
      font-size: 20px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(119, 65, 23, 1);
      line-height: 28px;
    }
    .checkvip {
      cursor: pointer;
      display: inline-block;
      text-align: center;
      width: 112px;
      height: 40px;
      background: rgba(202, 152, 82, 1);
      border-radius: 4px;

      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      // width: 158px;
      // height: 32px;
      // border-radius: 10px;
      // background: rgba(202, 152, 82, 1);
      // border-radius: 16px;
      // line-height: 32px;
      // font-size: 14px;
      // font-family: PingFangSC-Regular;
      // font-weight: 400;
      // color: rgba(255, 255, 255, 1);
    }
  }
}
</style>
